<script type="text/ecmascript-6">
import axios from 'axios'

import JsonTree from 'vue-json-tree'
export default {
	name: 'debug',
	components: {
		'json-tree': JsonTree,
	},
	data() {
		return {
			history: {},
			cosine_threshold: 0,
			commands_gr_or_eq_cosine_threshold: [],
			arrowUpDownCursor: null,
			message: '',
			matched_command: {
				command_id: 0,
				command_name: '',
				service_name: '',
				score: 0,
				cosine: 0,
			},
			chatbot_id: null,
			chatbots: [],
			treeLevel: 7,
			sample: 'No result',
			sample_response: 'No data',
			similar_vectors: {
				top_commands: [],
				top_examples: [],
			},
			similar_commands: {
				top_commands: [],
				top_examples: [],
			},
			sender_bank: {
				command_id: 0,
				cursor: 0,
				in_progress: false,
				msg: '',
				prompt: {
					vars: [],
				},
				reply_source: 'bot',
				vars: [],
			},
		}
	},
	methods: {
		init() {
			this.$root.loader = !true
			if (this.$refs.input) {
				this.$refs.input.focus()
				window.addEvent && window.addEvent(this.$refs.input, 'keyup', this.handleOnKeyUp)
			}
		},
		resetWebData(self = this) {
			self = Object.assign(self, {
				cosine_threshold: 0,
				commands_gr_or_eq_cosine_threshold: [],
				arrowUpDownCursor: null,
				matched_command: {
					command_id: 0,
					command_name: '',
					service_name: '',
					score: 0,
					cosine: 0,
				},
				chatbot_id: null,
				chatbots: [],
				treeLevel: 7,
				sample: 'No result',
				sample_response: 'No data',
				similar_vectors: {
					top_commands: [],
					top_examples: [],
				},
				similar_commands: {
					top_commands: [],
					top_examples: [],
				},
				sender_bank: {
					command_id: 0,
					cursor: 0,
					in_progress: false,
					msg: '',
					prompt: {
						vars: [],
					},
					reply_source: 'bot',
					vars: [],
				},
			})
		},
		run() {
			this.resetWebData()
			this.$validator.validateAll(['message', 'chatbot_id']).then((result) => {
				if (result) {
					if (this.history[this.message]) {
						this.handleOnReceived(this.message, this.history[this.message], false)
					} else {
						this.$root.loader = true
						axios
							.get(`/debug?message=${this.message}`)
							.then(({data}) => {
								this.handleOnReceived(this.message, data)
							})
							.catch((err) => {
								this.$root.loader = !true
								this.sample = err
							})
					}
				}
			})
		},

		handleOnKeyUp(e) {
			var msgs = Object.keys(this.history)
			var isUp = e.keyCode === 38
			var isDown = e.keyCode === 40
			if (isUp || isDown) {
				preventDefaultEvent(e)
				if (this.arrowUpDownCursor === null) {
					this.arrowUpDownCursor = msgs.length
				}
				if (isUp && msgs[this.arrowUpDownCursor - 1]) {
					--this.arrowUpDownCursor
				}
				if (isDown && msgs[this.arrowUpDownCursor + 1]) {
					++this.arrowUpDownCursor
				}
				if (msgs[this.arrowUpDownCursor]) {
					this.message = msgs[this.arrowUpDownCursor]
					if (this.history[this.message]) {
						this.handleOnReceived(this.message, this.history[this.message], false)
						if (window.selectionStart) {
							window.selectionStart = window.selectionEnd = this.value.length
						}
					}
				}
			}
		},

		handleOnReceived(msg, data, update_arrow = true) {
			msg = msg.trim()
			this.$root.loader = !true
			this.sample = data.data
			data = this.sample

			this.matched_command = Object.assign(
				{
					command_id: 0,
					command_name: '',
					service_name: '',
					score: 0,
					cosine: 0,
				},
				data.matched_command
			)

			this.sample_response = data.replies

			this.cosine_threshold = data.cosine_threshold
			this.similar_vectors.top_commands = data.similar_vectors.top_commands
			this.similar_vectors.top_examples = data.similar_vectors.top_examples.filter((ex) => ex.cosine > 0)
			this.similar_commands.top_commands = data.similar_commands.top_commands
			this.similar_commands.top_examples = data.similar_commands.top_examples.filter((ex) => ex.score > 0)
			this.sender_bank = data.sender_bank

			this.commands_gr_or_eq_cosine_threshold = this.similar_vectors.top_examples.filter(
				(ex) => parseFloat(ex.cosine) >= parseFloat(this.cosine_threshold)
			)

			if (update_arrow) {
				var msgs_count = Object.keys(this.history).length
				this.arrowUpDownCursor = msgs_count ? msgs_count - 1 : msgs_count
			}
		},
	},
	created() {
		this.init()
	},
	destroyed() {
		removeEvent(this.$refs.input, 'keyup', this.handleOnKeyUp)
	},
}
</script>
<template>
    <div class="animated fadeIn">
        <div class="row">
            <div class="col-sm-12">
                <h3 class="mb-4">Command Debugger</h3>

                <form @submit.prevent="run">
                    <p class="control">
                        <label v-hide>{{ $t('message') }}</label>
                        <input
                            ref="input"
                            name="message"
                            type="text"
                            autocomplete="off"
                            v-model="message"
                            v-validate="'required'"
                            placeholder="Enter a message.."
                            :class="{'form-control': true, 'is-invalid': errors.has('message')}"
                        />
                        <span
                            v-show="errors.has('message')"
                            class="invalid-feedback"
                        >{{ $t(errors.first('message')) }}</span>
                    </p>
                </form>
            </div>
            <div class="col-md-2">
                <p class="control" v-hide>
                    <button class="btn btn-md btn-primary" type="button" @click="run">
                        <i class="fa fa-dot-circle-o"></i>
                        {{ $t('run') }}
                    </button>
                </p>
            </div>
            <div class="col-md-10"></div>
            <div class="col-sm-12">
                <b-card>
                    <div slot="header">
                        <b>Matched command</b>
                    </div>
                    <table class="table table-bordered table-striped table-sm">
                        <thead>
                            <tr>
                                <td>Command id</td>
                                <td>command name</td>
                                <td>Command score</td>
                                <td>Command cosine</td>
                                <td>Service name</td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-if="matched_command.command_id > 0">
                                <td>{{matched_command.command_id}}</td>
                                <td>{{matched_command.command_name}}</td>
                                <td>{{matched_command.score}}</td>
                                <td>{{matched_command.cosine}}</td>
                                <td>{{matched_command.service_name}}</td>
                            </tr>
                            <tr v-else v-cloak>
                                <td colspan="5">
                                    <div class="text-center">{{ $t('no data') }}</div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </b-card>

                <b-card>
                    <div slot="header">
                        <b>AI recognition</b>
                    </div>
                    <p class="h5">Top matched examples</p>
                    <table class="table table-bordered table-striped table-sm">
                        <thead>
                            <tr>
                                <!-- <td>example id</td> -->
                                <!-- <td>command id</td> -->
                                <td>command name</td>
                                <td>example text</td>
                                <td>text score (cosine)</td>
                                <td>service name</td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                v-for="(ex, index) in similar_vectors.top_examples"
                                :key="`similar_vectors.top_examples-${index}`"
                            >
                                <!-- <td>{{ ex._id }}</td> -->
                                <!-- <td>{{ ex.command_id }}</td> -->
                                <td>{{ ex.command.command_name }}</td>
                                <td>{{ ex.example_text }}</td>
                                <td>{{ ex.cosine.toFixed(3) }}</td>
                                <td>{{ ex.command.service.service_name }}</td>
                            </tr>
                            <tr v-if="!similar_vectors.top_examples.length" v-cloak>
                                <td colspan="5">
                                    <div class="text-center">{{ $t('no data') }}</div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </b-card>

                <b-card v-if="!commands_gr_or_eq_cosine_threshold.length">
                    <div slot="header">
                        <b>NLP recognition</b>
                    </div>
                    <p class="h5">Top matched examples</p>
                    <table class="table table-bordered table-striped table-sm">
                        <thead>
                            <tr>
                                <td>example_id</td>
                                <td>command_id</td>
                                <td>command_name</td>
                                <td>example_text</td>
                                <td>text score (similarity)</td>
                                <td>service_name</td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                v-for="(ex, index) in similar_commands.top_examples"
                                :key="`similar_commands.top_examples-${index}`"
                            >
                                <td>{{ ex._id }}</td>
                                <td>{{ ex.command_id }}</td>
                                <td>{{ ex.command_name }}</td>
                                <td>{{ ex.example_text }}</td>
                                <td>{{ ex.score.toFixed(3) }}</td>
                                <td>{{ ex.service_name }}</td>
                            </tr>
                            <tr v-if="!similar_commands.top_examples.length" v-cloak>
                                <td colspan="5">
                                    <div class="text-center">{{ $t('no data') }}</div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </b-card>

                <b-card
                    v-if="!Array.isArray(sender_bank.vars) && Object.keys(sender_bank.vars).length"
                >
                    <div slot="header">
                        <b>Command variables</b>
                    </div>
                    <p class="h5">Variables</p>
                    <table class="table table-bordered table-striped table-sm">
                        <thead>
                            <tr>
                                <td>variable name</td>
                                <td>variable matched value</td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="var_name in Object.keys(sender_bank.vars)">
                                <td>{{ var_name }}</td>
                                <td>{{ sender_bank.vars[var_name] }}</td>
                            </tr>
                        </tbody>
                    </table>
                </b-card>

                <b-card class="bg-danger" v-if="commands_gr_or_eq_cosine_threshold.length >= 2">
                    <div slot="header">
                        <b>Confolicted commands</b>
                    </div>
                    <p class="h5">Top matched examples</p>
                    <table class="table table-bordered table-striped table-sm">
                        <thead>
                            <tr>
                                <td>example id</td>
                                <td>command id</td>
                                <td>command name</td>
                                <td>example text</td>
                                <td>text score (cosine)</td>
                                <td>service name</td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(ex, index) in commands_gr_or_eq_cosine_threshold" class>
                                <td>{{ ex.example_id }}</td>
                                <td>{{ ex.command_id }}</td>
                                <td>{{ ex.command_name }}</td>
                                <td>{{ ex.example_text }}</td>
                                <td>{{ ex.cosine.toFixed(3) }}</td>
                                <td>{{ ex.service_name }}</td>
                            </tr>
                        </tbody>
                    </table>
                </b-card>

                <b-card class="p-0">
                    <div slot="header">
                        <b>Sample response</b>
                    </div>
                    <span class="json-tree json-tree-root" style="min-height: 300px;">
                        <json-tree :data="sample_response" :level="treeLevel"></json-tree>
                    </span>
                </b-card>

                <span class="json-tree json-tree-root" style="min-height: 500px;" v-hide>
                    <json-tree :data="sample" :level="treeLevel"></json-tree>
                </span>
            </div>
        </div>
    </div>
</template>
